import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import MaterialTable from 'material-table';

import UserInteractionProfile from '../UserInteractionProfile';

const styles = theme => ({
  displayName: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 10,
  },
  tableContainer: {
    maxWidth: 1000,
    '& table:first-child': {
      '& tr': {
        '& td:first-child, th:first-child': {
          backgroundColor: '#ffffff',
          position: 'sticky',
          left: 0,
          zIndex: 11,
        },
        '& th:first-child': {
          zIndex: 11,
        },
      },
    },
  },
});

class OnboardingUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userProfileDialog: true,
      userData: null,
    };
    const { classes } = props;
    this.columns = [
      {
        title: 'User',
        field: 'name',
        render: rowData => {
          const name = rowData.name ? rowData.name : 'Anonymous user';
          return (
            <div className={classes.displayName}>
              <Avatar className={classes.avatar} src={rowData.profile_pic}>
                <PersonOutlineOutlinedIcon />
              </Avatar>
              {name}
            </div>
          );
        },
      },
      { title: 'steps completed', field: 'stepsCompleted' },
      { title: 'favorites', field: 'favorites' },
    ];
  }

  closeUserProfileDialog = event => {
    this.setState({
      userProfileDialog: false,
      userData: null,
    });
  };

  openUserProfileDialog = rowData => {
    this.setState({
      userProfileDialog: true,
      userData: rowData,
    });
  };
  render() {
    return (
      <React.Fragment>
        <MaterialTable
          elevation={0}
          // key={pageSize}
          options={{
            // pageSize: pageSize,
            // filtering: true,
            toolbar: true,
            paging: true,
            // exportButton: true,
            sorting: false,
          }}
          columns={this.columns}
          data={query =>
            new Promise((resolve, reject) => {
              const per_page = 5;
              const page = query.page + 1;
              let filter = {};
              query.filters.forEach(singleFilter => {
                filter[singleFilter.column.field] = singleFilter.value;
              });
              if (query.search.length > 0) {
                filter.name = query.search;
              }

              this.props.getOnboardingUsers(filter, per_page, page).then(data => {
                resolve({
                  data: data.docs,
                  page: data.page - 1,
                  totalCount: data.total,
                });
              });
            })
          }
          title="Users"
          onRowClick={(event, rowData) => this.openUserProfileDialog(rowData)}
        />
        {this.state.userData && (
          <UserInteractionProfile
            userData={this.state.userData}
            open={this.state.userProfileDialog}
            onClose={this.closeUserProfileDialog}
          />
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(OnboardingUsers);
